export const pages = {
	'boltGallery': { id: 'boltGallery', page: 'gallery', getter: () => import(/* webpackChunkName: 'boltGallery' */ 'components/bolt/gallery/gallery') },
	'boltPreviewPanel': { id: 'boltPreviewPanel', page: 'home', getter: () => import(/* webpackChunkName: 'boltPreviewPanel' */ 'components/bolt/home/home') },
	'offers': { id: 'offers', page: 'toutHorizontal', getter: () => import(/* webpackChunkName: 'offers' */ 'components/bolt/toutHorizontal/toutHorizontal') },
	'merchandise': { id: 'merchandise', page: 'merchandise', getter: () => import(/* webpackChunkName: 'merchandise' */ 'components/bolt/merchandise/merchandise') },
	'productFeatures': { id: 'productFeatures', page: 'toutVertical', getter: () => import(/* webpackChunkName: 'productFeatures' */ 'components/bolt/toutVertical/toutVertical') }
};
export const sections = [
	{ id: 'boltPreviewPanel', getter: () => import(/* webpackChunkName: "boltPreviewPanel" */ 'components/bolt/previewPanel/previewPanel'), component: 'previewPanel' },
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "boltWatchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
